import React from 'react';
import PreBetRoundPreviewPC from './PreBetRoundPreviewPC';
import PreBetRoundPreviewSP from './PreBetRoundPreviewSP';

function PreBetRoundPreview({ viewProps }) {
  return viewProps?.responsiveMode === 'mobile'
    ? <PreBetRoundPreviewSP viewProps={viewProps} />
    : <PreBetRoundPreviewPC viewProps={viewProps} />;
}

export default PreBetRoundPreview;

